var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.58 10.7333C20.58 9.86999 20.5099 9.23999 20.3583 8.58667H10.5V12.4833H16.2866C16.17 13.4517 15.54 14.91 14.14 15.8899L14.1203 16.0204L17.2374 18.4351L17.4533 18.4567C19.4366 16.625 20.58 13.93 20.58 10.7333Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 21C13.3349 21 15.7148 20.0666 17.4532 18.4567L14.1399 15.8899C13.2532 16.5083 12.0632 16.9399 10.4999 16.9399C7.72325 16.9399 5.3666 15.1083 4.52652 12.5767L4.40339 12.5871L1.16226 15.0955L1.11987 15.2133C2.84652 18.6433 6.3932 21 10.4999 21Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52662 12.5767C4.30496 11.9233 4.17668 11.2233 4.17668 10.5C4.17668 9.77661 4.30496 9.07664 4.51496 8.42331L4.50909 8.28417L1.22735 5.73553L1.11997 5.78661C0.408338 7.20996 0 8.80832 0 10.5C0 12.1916 0.408338 13.7899 1.11997 15.2133L4.52662 12.5767Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 4.05997C12.4715 4.05997 13.8015 4.91164 14.5599 5.62335L17.5232 2.73C15.7033 1.03834 13.3349 0 10.4999 0C6.3932 0 2.84652 2.35665 1.11987 5.78662L4.51486 8.42333C5.3666 5.89166 7.72325 4.05997 10.4999 4.05997Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.020551e94a95ebc072b269398d6ed9c8.svg";
export { ForwardRef as ReactComponent };